/**
 * ID: bh-role-guard-service
 * Name: BH Role Guard Service
 * Description: Service for role-based access control
 * Version: 1
 *
 * ==============================
 * Change Log
 * ==============================
 * 2024-01-XX - Initial dev
 */
import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { User } from 'src/app/models/user';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const authUser = this.authService.getAuthUser();
    const requiredRoles = route.data['roles'] as string[];
    const allowPublic = route.data['allowPublic'] as boolean;

    // Allow public access if specified
    if (allowPublic && !authUser) {
      return true;
    }

    // Check if user is authenticated
    if (!authUser || !authUser.userId) {
      return this.router.createUrlTree(['/login']);
    }

    // Check if roles are required
    if (requiredRoles && requiredRoles.length > 0) {
      const userRoles = this.authService.getUserRoles(authUser);
      const hasRequiredRole = requiredRoles.some(role =>
        userRoles.includes(role)
      ) || this.authService.isAdminOrSysAdmin(authUser);

      if (!hasRequiredRole) {
        // Redirect to unauthorized page or home
        return this.router.createUrlTree(['/']);
      }
    }

    return true;
  }
}

